import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import DuePaymentsModal from "../../layoutComponents/DuePayments/DuePaymentsModal";
import { useDuePayments } from "../../context/DuePaymentsContext";
import { duePaymentsService } from "../../layoutComponents/DuePayments/duePaymentsService";

const MOCK_PAYMENTS = [
  {
    id: "dp_001",
    type: "miller",
    entityId: "miller_001",
    entityName: "ABC Rice Mill",
    poId: "PO-2024-001",
    soId: "SO-2024-001",
    billId: "BILL-001",
    amountDue: 500000,
    amountPaid: 0,
    currency: "INR",
    dueDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    status: "overdue",
    discount: { eligible: true, percentage: 2, expiryDays: 7, savings: 10000 },
  },
  {
    id: "dp_002",
    type: "miller",
    entityId: "miller_002",
    entityName: "XYZ Rice Mill",
    poId: "PO-2024-002",
    soId: "SO-2024-002",
    billId: "BILL-002",
    amountDue: 350000,
    amountPaid: 100000,
    currency: "INR",
    dueDate: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString(),
    status: "pending",
    discount: { eligible: true, percentage: 2, expiryDays: 5, savings: 7000 },
  },
  {
    id: "dp_003",
    type: "broker",
    entityId: "broker_001",
    entityName: "Global Trade Brokers",
    poId: "PO-2024-003",
    soId: "SO-2024-003",
    billId: "BILL-003",
    amountDue: 175000,
    amountPaid: 0,
    currency: "INR",
    dueDate: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(),
    status: "pending",
    discount: { eligible: true, percentage: 1.5, expiryDays: 10, savings: 2625 },
  },
  {
    id: "dp_004",
    type: "miller",
    entityId: "miller_003",
    entityName: "PQR Rice Mill",
    poId: "PO-2024-004",
    soId: "SO-2024-004",
    billId: "BILL-004",
    amountDue: 280000,
    amountPaid: 0,
    currency: "INR",
    dueDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    status: "overdue",
    discount: { eligible: false, percentage: 0, expiryDays: 0, savings: 0 },
  },
  {
    id: "dp_005",
    type: "broker",
    entityId: "broker_002",
    entityName: "Premier Brokers",
    poId: "PO-2024-005",
    soId: "SO-2024-005",
    billId: "BILL-005",
    amountDue: 95000,
    amountPaid: 25000,
    currency: "INR",
    dueDate: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString(),
    status: "pending",
    discount: { eligible: true, percentage: 3, expiryDays: 15, savings: 2850 },
  },
  {
    id: "dp_006",
    type: "miller",
    entityId: "miller_004",
    entityName: "Sunrise Rice Mill",
    poId: "PO-2024-006",
    soId: "SO-2024-006",
    billId: "BILL-006",
    amountDue: 420000,
    amountPaid: 0,
    currency: "INR",
    dueDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString(),
    status: "pending",
    discount: { eligible: true, percentage: 2, expiryDays: 7, savings: 8400 },
  },
];

const MOCK_SUMMARY = {
  totalDue: 1840000,
  overdueCount: 2,
  urgentCount: 1,
  potentialSavings: 30875,
  millerDueCount: 4,
  brokerDueCount: 2,
};

const mapPaymentFromAPI = (apiPayment) => {
  return {
    id: apiPayment.id || apiPayment.pk || apiPayment.due_payment_id || "",
    type: apiPayment.type || apiPayment.entity_type || apiPayment.party_type || "",
    entityId: apiPayment.entity_id || apiPayment.miller_id || apiPayment.broker_id || apiPayment.party_id || "",
    entityName: apiPayment.entity_name || apiPayment.miller_name || apiPayment.broker_name || apiPayment.party_name || apiPayment.name || "",
    poId: apiPayment.po_id || apiPayment.purchase_order_id || apiPayment.purchase_order || "",
    soId: apiPayment.so_id || apiPayment.sales_order_id || apiPayment.sales_order || "",
    billId: apiPayment.bill_id || apiPayment.invoice_id || apiPayment.bill_number || "",
    amount: parseFloat(apiPayment.brokerage_amount_for_bri || apiPayment.miller_final_amount || 0),
    amountDue: parseFloat(apiPayment.amount_due || apiPayment.amount || apiPayment.balance || apiPayment.due_amount || 0),
    amountPaid: parseFloat(apiPayment.amount_paid || apiPayment.paid_amount || apiPayment.paid || 0),
    currency: apiPayment.currency || "INR",
    dueDate: apiPayment.due_date || apiPayment.dueDate || apiPayment.payment_due_date || new Date().toISOString(),
    status: apiPayment.status || "pending",
    dispatchDate: apiPayment.arrival_date || "",
    BillNo: apiPayment.bill_no || "",
    discount: {
      eligible: apiPayment.discount?.eligible || apiPayment.is_discount_eligible || apiPayment.discount_available || false,
      percentage: parseFloat(apiPayment.discount?.percentage || apiPayment.discount_percentage || apiPayment.discount_percent || 0),
      expiryDays: parseInt(apiPayment.discount?.expiry_days || apiPayment.discount_expiry_days || apiPayment.expiry_days || 0),
      savings: parseFloat(apiPayment.discount?.savings || apiPayment.discount_amount || apiPayment.savings || 0),
    },
  };
};

const mapSummaryFromAPI = (apiSummary) => {
  return {
    totalDue: parseFloat(parseFloat(apiSummary.miller?.total_pending_amount || 0) + parseFloat(apiSummary.broker?.total_pending_amount || 0) + parseFloat(apiSummary.transporter?.total_pending_amount || 0) || 0),
    totalAmount: parseFloat(parseFloat(apiSummary?.miller?.total_payable_amount || 0) + parseFloat(apiSummary?.broker?.total_payable_amount || 0) + parseFloat(apiSummary?.transporter?.total_payable_amount || 0) || 0),
    totalPaidAmount: parseFloat(parseFloat(apiSummary?.miller?.total_paid_amount || 0) + parseFloat(apiSummary?.broker?.total_paid_amount || 0) + parseFloat(apiSummary?.transporter?.total_paid_amount || 0) || 0),
    apiSummary,
    overdueCount: parseInt(apiSummary.overdue_count || apiSummary.overdueCount || apiSummary.overdue || 0),
    urgentCount: parseInt(apiSummary.urgent_count || apiSummary.urgentCount || apiSummary.urgent || 0),
    potentialSavings: parseFloat(apiSummary.potential_savings || apiSummary.potentialSavings || apiSummary.savings || apiSummary.total_discount || 0),
    millerDueCount: parseInt(apiSummary.miller_due_count || apiSummary.millerDueCount || apiSummary.miller_count || apiSummary.miller.bills_count || 0),
    brokerDueCount: parseInt(apiSummary.broker_due_count || apiSummary.brokerDueCount || apiSummary.broker_count || apiSummary.broker.bills_count || 0),
  };
};

const DuePaymentsComponent = () => {
  const dispatch = useDispatch();
  const { state: contextState, dispatch: contextDispatch } = useDuePayments();
  const user = useSelector((state) => state.authentication?.user);

  const [payments, setPayments] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [pagination, setPagination] = useState({ next: null, count: 0 });
  const [useMockData, setUseMockData] = useState(true);

  const fetchSummary = async () => {
    try {
      const response = await duePaymentsService.getSummary();
      console.log("Summary API Response:", response);
      if (response && !response.error) {
        const mappedSummary = mapSummaryFromAPI(response);
        // if (mappedSummary.totalDue > 0 || mappedSummary.overdueCount > 0) {
          setSummary(mappedSummary);
          setUseMockData(false);
        // }
      }
    } catch (error) {
      console.log("Using mock summary data", error);
    }
  };

  const fetchPayments = async (filterType = "all", nextURL = null, append = false) => {
    let response;
    if (filterType === "all") {
      response = nextURL 
        ? await duePaymentsService.getAllWithNextURL(nextURL)
        : await duePaymentsService.getAll(1);
    } else if (filterType === "miller") {
      response = nextURL
        ? await duePaymentsService.getMillersWithNextURL(nextURL)
        : await duePaymentsService.getMillers(1);
    } else if (filterType === "broker") {
      response = nextURL
        ? await duePaymentsService.getBrokersWithNextURL(nextURL)
        : await duePaymentsService.getBrokers(1);
    }

    console.log(`${filterType} API Response:`, response);

    if (response && !response.error) {
      const results = Array.isArray(response) 
        ? response 
        : (response.results || response.data || []);
      
      const mappedPayments = results.map(mapPaymentFromAPI);
      
      if (mappedPayments.length > 0) {
        setPayments((prev) => append ? [...prev, ...mappedPayments] : mappedPayments);
        setPagination({
          next: response.next || null,
          count: response.count || mappedPayments.length
        });
        setUseMockData(false);
      }
    }
  };

  const loadMore = useCallback(async () => {
    if (pagination.next && !loadingMore && !useMockData) {
      await fetchPayments("all", pagination.next, true);
    }
  }, [pagination.next, loadingMore, useMockData]);

  useEffect(() => {
    if (user?.uid) {
      fetchSummary();
      fetchPayments("all");
    }
  }, [user?.uid]);

  // useEffect(() => {
  //   if (summary) {
  //     const urgentCount = summary.overdueCount + summary.urgentCount;
  //     contextDispatch({ type: "UPDATE_BELL_COUNT", payload: urgentCount });
  //   }
  // }, [summary, contextDispatch]);

  const handleCloseModal = () => {
    contextDispatch({ type: "CLOSE_MODAL" });
  };

  const handleFilterChange = (filterType) => {
    fetchPayments(filterType);
  };

  const handleLoadMore = () => {
    loadMore();
  };

  const displayPayments = payments.length > 0 ? payments : [];
const displaySummary = summary?.totalDue > 0 || summary?.totalAmount > 0 ? summary : {totalAmount: 0, totalDue: 0, totalPaidAmount: 0};

  return (
    <DuePaymentsModal
      open={contextState.modalOpen}
      onClose={handleCloseModal}
      payments={displayPayments}
      summary={displaySummary}
      loading={loading}
      loadingMore={loadingMore}
      pagination={pagination}
      onFilterChange={handleFilterChange}
      onLoadMore={handleLoadMore}
      useMockData={useMockData}
    />
  );
};

export default DuePaymentsComponent;
